(function () {
  if (window.MBProductTabs) return;

  function getTabs(root) {
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return [];
    return Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
  }

  function getPanels(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
  }

  function activateTab(root, index, moveFocus) {
    var tabs = getTabs(root);
    var panels = getPanels(root);
    if (!tabs.length) return;

    var next = index;
    if (next < 0) next = tabs.length - 1;
    if (next >= tabs.length) next = 0;

    tabs.forEach(function (tab, i) {
      var selected = i === next;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    panels.forEach(function (panel, i) {
      if (i === next) {
        panel.classList.add('is-active');
        panel.removeAttribute('hidden');
      } else {
        panel.classList.remove('is-active');
        panel.setAttribute('hidden', '');
      }
    });

    if (moveFocus && tabs[next]) tabs[next].focus();
  }

  function enhance(root) {
    if (!root || root.getAttribute('data-mb-tabs-ready') === 'true') return;
    root.setAttribute('data-mb-tabs-ready', 'true');
    root.classList.add('mb-product-tabs--js');

    var tabs = getTabs(root);
    if (!tabs.length) return;

    var selectedIndex = 0;
    tabs.forEach(function (tab, i) {
      if (tab.getAttribute('aria-selected') === 'true') selectedIndex = i;
    });
    activateTab(root, selectedIndex, false);

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activateTab(root, i, false);
      });

      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        var nextIndex = null;

        if (key === 'ArrowRight' || key === 'Right') {
          nextIndex = i + 1;
        } else if (key === 'ArrowLeft' || key === 'Left') {
          nextIndex = i - 1;
        } else if (key === 'Home') {
          nextIndex = 0;
        } else if (key === 'End') {
          nextIndex = tabs.length - 1;
        }

        if (nextIndex === null) return;
        event.preventDefault();
        activateTab(root, nextIndex, true);
      });
    });
  }

  function showSpecsForVariant(root, variantId) {
    if (!root || !variantId) return;
    var tables = root.querySelectorAll('[data-mb-spec-table]');
    if (!tables.length) return;

    var matchId = String(variantId);
    var found = false;

    Array.prototype.forEach.call(tables, function (table) {
      var isMatch = String(table.getAttribute('data-variant-id')) === matchId;
      table.hidden = !isMatch;
      if (isMatch) found = true;
    });

    var empty = root.querySelector('[data-mb-spec-empty]');
    if (empty) empty.hidden = found;
  }

  function getTabsSection(root) {
    if (!root || !root.closest) return null;
    return root.closest('section') || root.closest('.shopify-section') || null;
  }

  function formForTarget(target) {
    if (!target || !target.closest) return null;
    return target.closest('variant-radios, variant-selects, product-form, form');
  }

  function readVariantId(target, section) {
    if (!target || !section) return '';
    if (!section.contains(target)) return '';

    if (target.name === 'id' && target.value) {
      return String(target.value);
    }

    var host = formForTarget(target);
    if (!host || !section.contains(host)) return '';

    var input = host.querySelector('input[name="id"]');
    if (input && input.value) return String(input.value);

    var sectionInput = section.querySelector('form[data-type="add-to-cart-form"] input[name="id"], .product-form input[name="id"], form.installment input[name="id"]');
    if (sectionInput && sectionInput.value) return String(sectionInput.value);

    return '';
  }

  function bindVariantListener() {
    if (document.documentElement.getAttribute('data-mb-tabs-variant-bound') === 'true') return;
    document.documentElement.setAttribute('data-mb-tabs-variant-bound', 'true');

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      var eventForm = formForTarget(target);
      var roots = document.querySelectorAll('[data-mb-product-tabs]');
      Array.prototype.forEach.call(roots, function (root) {
        var section = getTabsSection(root);
        if (!section) return;
        if (eventForm) {
          if (!section.contains(eventForm)) return;
        } else if (!section.contains(target)) {
          return;
        }

        var variantId = readVariantId(target, section);
        if (!variantId) return;
        showSpecsForVariant(root, variantId);
      });
    });
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = context.querySelectorAll('[data-mb-product-tabs]');
    Array.prototype.forEach.call(roots, enhance);
    bindVariantListener();
  }

  window.MBProductTabs = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
